import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

interface IComplianceScoringGuidelinesModalProps {
  setIsOpen: (isOpen: boolean) => void;
}

const ComplianceScoringGuidelines: React.FC<
  IComplianceScoringGuidelinesModalProps
> = ({ setIsOpen }) => {
  return (
    <div className='modal-right'>
      <div style={{ float: 'right' }}>
        <div
          className='classify-container-footer-clear-text'
          onClick={() => setIsOpen(false)}
          style={{ cursor: 'pointer' }}
        >
          X Close
        </div>
      </div>
      <div className='module-header-modal'>
        <h5>Compliance Score Evaluation Criteria</h5>

        <details open>
          <summary>1) HTS Classification Accuracy</summary>
          <p>
            Reduce the compliance score by <strong>10%</strong> for each of the
            following conditions:
          </p>
          <ol>
            <li>HTS code is missing.</li>
            <li>HTS code is invalid with the specified country of origin.</li>
            <li>
              Product description quality is insufficient when measured against
              official HTS classification language (long-term objective).
            </li>
          </ol>
          <p>
            <strong>Required data points:</strong>
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li>HTS code</li>
            <li>Product description</li>
          </ul>
        </details>
        <details open>
          <summary>2) Duty and Tariff Validation</summary>
          <p>
            Reduce the compliance score by <strong>10%</strong> for each of the
            following conditions:
          </p>
          <p>
            <ol>
              <li>Total stacked duty/tariff calculation is incorrect.</li>
              <li>
                Stacking validation does not correctly apply exclusions or
                exemptions.
              </li>
            </ol>
          </p>
          <p>
            <strong>Required data points for calculation:</strong>
          </p>
          <p>
            <ul style={{ marginLeft: '20px' }}>
              <li>HTS code</li>
              <li>Country of origin</li>
              <li>Entry date and loading date</li>
              <li>Aluminum and steel declared values</li>
            </ul>
          </p>
        </details>
        <details open>
          <summary>3) Customs Flags (No Score Reduction)</summary>
          <p>
            These indicators do not reduce the compliance score but should be
            displayed with a warning icon (
            <ReportProblemOutlinedIcon style={{ color: 'var(--mid-color)' }} />
            ):
          </p>
          <p>
            <ul style={{ marginLeft: '20px' }}>
              <li>
                <ReportProblemOutlinedIcon
                  style={{ color: 'var(--mid-color)' }}
                />{' '}
                AD/CVD flag <em>(country of origin required)</em>
              </li>
              <li>
                <ReportProblemOutlinedIcon
                  style={{ color: 'var(--mid-color)' }}
                />{' '}
                PGA codes
              </li>
              <li>
                <ReportProblemOutlinedIcon
                  style={{ color: 'var(--mid-color)' }}
                />{' '}
                CPSC codes
              </li>
              <li>
                <ReportProblemOutlinedIcon
                  style={{ color: 'var(--mid-color)' }}
                />{' '}
                Forced labor codes
              </li>
              <li>
                <ReportProblemOutlinedIcon
                  style={{ color: 'var(--mid-color)' }}
                />{' '}
                Future: steel or aluminum license requirements
              </li>
            </ul>
          </p>
        </details>
      </div>
    </div>
  );
};

export default ComplianceScoringGuidelines;
